import * as yup from "yup"
import { Edizione } from "../../types"

export function initialValuesEdizione(edizione?: Edizione | undefined) {
  if (edizione) {
    return edizione
  }
  return {
    titolo: "",
    opera: undefined,
    citta: undefined,
    anno: "",
    committenti: [],
    stampatori: [],
    autori_secondari: [],
    formato: "",
    collazione: "",
    incisioni: "",
    note: "",
    bozza: true,
  }
}


export function validationSchemaEdizione(showOpera: boolean) {
  if (!showOpera) {
    return yup.object().shape({
      anno: yup.number().required("Campo obbligatorio"),
      citta: yup.number().required("Campo obbligatorio"),
      formato: yup.number().required("Campo obbligatorio"),
    })
  } else {
    return yup.object().shape({
      opera: yup.number().required("Campo obbligatorio"),
      anno: yup.number().required("Campo obbligatorio"),
      citta: yup.number().required("Campo obbligatorio"),
      formato: yup.number().required("Campo obbligatorio"),
    })
  }
}
